import { SelectionAge, SelectionEvent } from './internal';
export class SelectionIndividualEvent extends SelectionEvent {
    getAge() {
        return this.get("AGE" /* Tag.Age */, null, SelectionAge);
    }
}
//# sourceMappingURL=SelectionIndividualEvent.js.map